import { lazyCalendarAutoSelectModule } from 'owa-calendar-module-calendar-auto-select';
import initializeAccountAndCalendars from './initializeAccountAndCalendars';
import { lazyAutoUpgradeOldModelCalendars } from 'owa-calendar-sharing-autoupgrade';
import { initializeFeature } from 'owa-feature-flags';
import { CalendarViewTypeEnum } from 'owa-calendar-view-type';
import { lazyLoadWorkloadScenarioSettings } from 'owa-workload-scenario-settings';
import { getUserConfiguration, isConsumer } from 'owa-session-store';

let hasBeenCalled = false;

/**
 * Initializes accounts, calendars, and settings necessary for OWA modules
 */
export default async function initializeCalendarsDataForModule() {
    // only allow single init per session
    if (hasBeenCalled) {
        return;
    }

    // STEP 0 - Mark init for session
    hasBeenCalled = true;

    // STEP 1 - Kick off async promises to load minimum data needed for module scenario
    const initPromises = [
        // initialize all accounts and associated calendars
        initializeAccountAndCalendars(),

        // initialize scenario settings for each account (since calendar ID setting is needed as part of boot flow)
        lazyLoadWorkloadScenarioSettings.importAndExecute(),
    ];

    // STEP 2 - Kick off background tasks that should occur close to initial render but are not necessarily blocking
    lazyCalendarAutoSelectModule.import();

    // STEP 3 - Block on resolution of init promises
    await Promise.all(initPromises);

    // STEP 4 - Kick off background tasks that can take place independent of initial render
    // start auto-upgrading old-model calendars to new-model calendars
    const userConfiguration = getUserConfiguration();
    initializeFeature('cal-sharing-autoUpgrade', () => {
        /**
                Client-side hueristics to make the autoUpgrade decision of old model calendars
                1. User is in day view
                2. User has split view turned on
                3. Only for business users
            */
        if (
            !isConsumer() &&
            userConfiguration?.ViewStateConfiguration?.CalendarViewTypeDesktop ==
                CalendarViewTypeEnum.Daily &&
            userConfiguration?.ViewStateConfiguration?.CalendarViewInSplitMode
        ) {
            lazyAutoUpgradeOldModelCalendars.importAndExecute();
        }
    });
}
